// src/main.jsx
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App.jsx';
import { AuthProvider } from './context/AuthContext.jsx';
import { MaintenanceProvider } from './context/MaintenanceContext.jsx';
import { CookieConsentProvider } from './context/CookieConsentContext.jsx';
import { PublicationProvider } from './context/PublicationContext.jsx';
import { TranslationProvider } from './components/i18n/TranslationProvider.jsx';

import '@fontsource-variable/orbitron';
import './styles/globals.css';
import './styles/components.css';

createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AuthProvider>
      <MaintenanceProvider>
        <CookieConsentProvider>
          <TranslationProvider>
            <PublicationProvider>
              <BrowserRouter>
                <App />
              </BrowserRouter>
            </PublicationProvider>
          </TranslationProvider>
        </CookieConsentProvider>
      </MaintenanceProvider>
    </AuthProvider>
  </React.StrictMode>
);

export { useAuth } from './context/AuthContext.jsx';
